import Logger from '../utils/Logger'
import { pick } from '../utils/PolyfillLodash'
import config, { searchTypes } from '../config'

const logger = new Logger()

const PRODUCT_ATTRIBUTES = [
  'name',
  'price',
  'wasPrice',
  'avgRating',
  'reviewsCount',
  'fastTrack',
  'specialOfferText',
  'hasVariations',
  'hasMultiplePrices',
  'freeDelivery',
  'badge',
  'variants',
  'deliverable',
  'reservable',
  'brand',
  'detailAttributes',
  'wasText',
  'relevancyRank',
  'definingAttributes'
]

function getSearchTermForSearchType({ searchType, inputSearchTerm, searchTerm }) {
  if (searchType === searchTypes.brandsNIC || searchType === searchTypes.NRS) {
    return inputSearchTerm
  }

  return searchTerm
}

function getSearchType({ searchType, brandSuggestions }) {
  if (!searchType) return null
  if (searchType === searchTypes.brandsNIC && brandSuggestions && brandSuggestions.length < 1) {
    return null
  }
  if (searchType === searchTypes.NRS && brandSuggestions && brandSuggestions.length < 1) {
    return null
  }

  return searchType
}

function getProductCount(response, ...args) {
  logger.debug('functionLogger', { ...args }, 'ProductHelper getProductCount')
  let productCount = null

  if (response && response.meta) {
    productCount = response.meta.totalData >= 0 ? response.meta.totalData : null
  }
  return productCount
}

function renameProductIdToPartNumber(variants) {
  if (!variants) return

  Object.keys(variants).forEach(variantType => {
    variants[variantType].forEach(variant => {
      if (!variant.partNumber) {
        variant.partNumber = variant.productId
        delete variant.productId
      }
    })
  })
}

function formatResponse(response) {
  if (response.data) {
    response.data.forEach(product => {
      product.attributes = pick(product.attributes, PRODUCT_ATTRIBUTES)
      renameProductIdToPartNumber(product.attributes.variants)
    })
  }

  return response
}

function getSuggestedTerm(suggestedBrands) {
  if (suggestedBrands && suggestedBrands.length) return suggestedBrands[0].text.toLowerCase()
  return null
}

function splitByRelevancy(products) {
  let productLists

  if (!Array.isArray(products)) {
    return [[], []]
  }

  const productCount = Array.isArray(products) && products.length > 30 ? products.length : 30
  const index = products.findIndex(product => product?.attributes?.relevancyRank === 2)
  if (index >= 0) {
    const firstRelevancy = products.slice(0, index)
    const secondRelevancy = products.slice(index, productCount)
    productLists = [firstRelevancy, secondRelevancy]
  } else {
    productLists = [products, []]
  }
  return productLists
}

function mergeContentInList(products, inspirationCards = []) {
  const firstIndex = 3
  const mergedProducts = [...products.slice(0, firstIndex), inspirationCards[0], ...products.slice(firstIndex)]
  const secondIndex = mergedProducts.length > 20 ? mergedProducts.length - 3 : mergedProducts.length
  return inspirationCards.length > 1
    ? [...mergedProducts.slice(0, secondIndex), inspirationCards[1], ...mergedProducts.slice(secondIndex)]
    : mergedProducts
}

function isSkuId(partNumber) {
  let skuId = partNumber
    ?.toString()
    .trim()
    .match(/^[\d]{3}\/?[\d]{3,4}$/g)

  if (!skuId) {
    return false
  }

  skuId = skuId[0].split('/').join('')
  return skuId.length === 7 || skuId.length === 6
}

function isStrictTucPrefixedTuSkuId(partNumber) {
  return /^(tuc)[\d]{8,18}$/g.test(partNumber.toString().trim())
}

function getProductPagePath(partNumber) {
  return `${config.getProductPath(partNumber)}`
}

export {
  getSuggestedTerm,
  formatResponse,
  renameProductIdToPartNumber,
  getProductCount,
  getSearchType,
  getSearchTermForSearchType,
  splitByRelevancy,
  mergeContentInList,
  isSkuId,
  isStrictTucPrefixedTuSkuId,
  getProductPagePath
}
